<template>
  <aside class="flex gap-8" :class="$attrs.class">
    <p class="text-static-default-mid body-2 flex-1">
      {{ i18n(translations.categories) }}
    </p>
    <RevLink
      class="body-2-link"
      :to="seeAllUrl"
      :tracking
      @click="$emit('click-see-all')"
      >{{ i18n(translations.see_all) }}</RevLink
    >
  </aside>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import translations from './NavCategoryHeader.translations'

defineProps<{
  seeAllUrl: RouteLocationRaw
  tracking?: Record<string, string>
}>()

defineEmits<{
  'click-see-all': []
}>()

const i18n = useI18n()
</script>
